import React from 'react';
import {
  Paper, Typography, List, ListItem, ListItemText, Divider,
} from '@mui/material';

const HOW_TO_STEPS = [
  {
    title: 'Choose the financial year for which you want your taxes to be calculated.',
  },
  {
    title: 'Select your age accordingly. Tax liability in India differs based on the age groups.',
  },
  {
    title: 'Click on `Go to Next Step`.',
  },
  {
    title: 'Assess your Gross Income.',
    body:
      'First, make a note of your annual gross salary. All of your compensation will be added in this, including your House Rent Allowance (HRA), Leave Travel Allowance (LTA), and other benefits like meal vouchers and mobile reimbursements. After this, calculate and use the exemptions from the salary components that are provided by the Income Tax department to further decrease your gross income, if relevant. The exemptions include HRA and LTA. Notably, the HRA exemption is only applicable if you live in rented apartments and submit receipts as proof. You can calculate your HRA by using an online HRA calculator.',
  },
  {
    title: 'Deductions under Income tax.',
    body:
      'After calculating your taxable income, you can further reduce it by incorporating some deductions. A standard deduction of Rs 50,000 is done from your gross income. Next, minus investments and expenses eligible for section 80C. Under 80C comes investment, savings, money spent on specific things or policies that give you tax benefits. Some of the most popular ways to claim this deduction are investments in PPF, ELSS Mutual Funds, EPF, Sukanya Smriddhi Yojana, and premiums paid for term insurance. To know more about the deduction amount, visit the income tax website.',
  },
  {
    title: 'Net Taxable Income.',
    body:
      'After standard deductions of Rs 75,000 for salaried person and exemptions, your net taxable income is derived. On this income, you are asked to give tax on the basis of tax slabs.',
  },
];

export default function TaxCalculatorInfo() {
  return (
    <Paper variant="outlined" sx={{ p: { xs: 2, md: 4 } }}>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
        What is Income Tax Calculator?
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        The government collects income tax on a person's income. A person, Hindu Undivided Family
        (HUF), business, cooperative societies, trusts and other entities are all required to abide
        by the income tax rules. Tax slabs are used to determine the income tax of a person on the
        basis of their age and income. The income of a person after subtracting the exemptions,
        deductions, and rebates becomes their taxable income. The deduction, exemptions and other
        rules may be revised on the basis of the Union Budget presented for that financial year.
        Now, to make calculations easier for all, Income Tax Calculator can be used to determine
        your taxable income.
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        The Income Tax calculator is an easy-to-use tool which helps you figure out the income tax
        which you are required to pay for the financial year. To use this application for FY
        2026-27, simply enter your age, residential status, income, investments in tax-saving
        instruments, and income from other sources. With the help of the Income Tax calculator, you
        can find out how much tax you owe after subtracting the tax exemptions, deductions and
        rebates.
      </Typography>

      <Divider sx={{ my: 3 }} />

      <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
        How to calculate Income tax for FY 2026-27 (AY 2027-28)?
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        To calculate your taxable income, here are some steps through which you can easily assess
        the amount you owe:
      </Typography>

      <List sx={{ listStyle: 'decimal', pl: 4 }}>
        {HOW_TO_STEPS.map((step, idx) => (
          <ListItem
            key={idx}
            sx={{ display: 'list-item', alignItems: 'flex-start', pl: 0.5, py: 0.5 }}
          >
            <ListItemText
              primary={
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {step.title}
                </Typography>
              }
              secondary={
                step.body ? (
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                    {step.body}
                  </Typography>
                ) : null
              }
            />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
}
